import apiClient, { getApiErrorMessage } from './apiClient';

const unwrapApiData = (data) => data?.data || data?.Data || data;

const unwrapApiList = (data) => {
  const unwrapped = unwrapApiData(data);

  if (Array.isArray(unwrapped)) {
    return unwrapped;
  }

  if (Array.isArray(unwrapped?.items)) {
    return unwrapped.items;
  }

  if (Array.isArray(unwrapped?.Items)) {
    return unwrapped.Items;
  }

  return [];
};

const normalizeLlmModelPricing = (model) => ({
  modelName: model?.modelName || model?.ModelName || '',
  promptTokensPricePerMillion:
    model?.promptTokensPricePerMillion ?? model?.PromptTokensPricePerMillion ?? 0,
  completionTokensPricePerMillion:
    model?.completionTokensPricePerMillion ?? model?.CompletionTokensPricePerMillion ?? 0,
  cachedTokensPricePerMillion:
    model?.cachedTokensPricePerMillion ?? model?.CachedTokensPricePerMillion ?? 0
});

const normalizeLlmCatalogModel = (model) => {
  const modelId = model?.modelId || model?.ModelId || '';
  const mode = model?.mode || model?.Mode || 'chat';
  return {
    modelId,
    displayName: model?.displayName || model?.DisplayName || modelId,
    ownedBy: model?.ownedBy || model?.OwnedBy || '',
    mode,
    provider: model?.provider || model?.Provider || 'AvalAI',
    descriptionFa: model?.descriptionFa || model?.DescriptionFa || '',
    descriptionEn: model?.descriptionEn || model?.DescriptionEn || '',
    promptTokensPricePerMillion:
      model?.promptTokensPricePerMillion ?? model?.PromptTokensPricePerMillion ?? 0,
    completionTokensPricePerMillion:
      model?.completionTokensPricePerMillion ?? model?.CompletionTokensPricePerMillion ?? 0,
    cachedTokensPricePerMillion:
      model?.cachedTokensPricePerMillion ?? model?.CachedTokensPricePerMillion ?? 0,
    isAvailable: model?.isAvailable ?? model?.IsAvailable ?? true,
    allowed: model?.allowed ?? model?.Allowed ?? true,
    lockedReason: model?.lockedReason || model?.LockedReason || null
  };
};

export const fetchLlmCatalogApi = async () => {
  try {
    const { data } = await apiClient.get('/llm/catalog');
    return unwrapApiList(data)
      .map(normalizeLlmCatalogModel)
      .filter((model) => model.modelId);
  } catch (error) {
    throw new Error(getApiErrorMessage(error, 'LLM catalog request failed.'));
  }
};

export const fetchLlmModelsPricingApi = async () => {
  try {
    const { data } = await apiClient.get('/llm/models');
    return unwrapApiList(data)
      .map(normalizeLlmModelPricing)
      .filter((model) => model.modelName);
  } catch (error) {
    throw new Error(getApiErrorMessage(error, 'LLM models pricing request failed.'));
  }
};
